import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';

import { api } from 'fr-shared/api';
import { IconFont, Navbar } from 'fr-shared/components';
import { AlertContext } from 'fr-shared/context';

import { Button } from 'portal/components';

import styles from './NavbarInsights.module.css';

const LogoExtra = <div className={styles.LogoExtra}>Insights Report</div>;

const NavbarInsights = ({ children, customer, customerContact, uuid }) => {
  const { setAlert } = useContext(AlertContext);
  const [sending, setSending] = useState(false);

  const handleEmailReport = () => {
    setSending(true);

    api
      .post(`/insights/${uuid}/email_report`)
      .then(() => {
        setAlert({
          color: 'success',
          message: `Report emailed to ${customerContact.email}`,
          autoClose: true,
        });
      })
      .catch(() => {
        setAlert({
          color: 'danger',
          message: 'Something went wrong sending the report. Please try again.',
          autoClose: true,
        });
      })
      .finally(() => setSending(false));
  };

  return (
    <>
      <Navbar
        container="sm"
        color="dark"
        className={`${styles.Navbar} sticky-top`}
        logoUrl={'/'}
        showLogoExtra={LogoExtra}
        showEnvironment={false}
      >
        <Button size="sm" onClick={handleEmailReport} loading={sending} showLoadingIcon>
          <IconFont name="email" right={true} /> Email Report
        </Button>
      </Navbar>

      <div className="container-sm flex align-items-center py-3">
        <div className="text-muted">
          {customerContact.name}, {customer.name}
        </div>

        {children}
      </div>
    </>
  );
};

NavbarInsights.propTypes = {
  children: PropTypes.node,
  customer: PropTypes.object,
  customerContact: PropTypes.object,
  uuid: PropTypes.string,
};

export default NavbarInsights;
